module.exports = __webpack_public_path__ + "static/media/futsal.3e4b898b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/futsal.svg
// module id = 378
// module chunks = 7